import logo from './logo.svg';
import './App.css';
import Chat from './Home';

function App() {
  return (
    <div className="App">
      <Chat />
    </div>
  );
}

export default App;